import { render } from "./ShareToUser.vue?vue&type=template&id=098ab47c"
import script from "./ShareToUser.vue?vue&type=script&lang=js"
export * from "./ShareToUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__